import type { FC } from 'react';
import { Flex, Icon } from '@ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { usePageContext } from 'vike-react/usePageContext';
import { DISCORD_LINK, LOGO_URL } from '@/constants/constants';
import { getLinkHref } from '@/utils/getLinkHref';
import styles from './Footer.module.css';

export const Footer: FC = () => {
    const { t } = useTranslation();
    const pageContext = usePageContext();

    const items = [
        { label: t('Footer_Menu_PrivacyPolicy'), href: getLinkHref(pageContext, '/privacy') },
        { label: t('Footer_Menu_Stats'), href: 'https://stats.vatsim-petersburg.com/', target: '_blank' },
        { label: t('Footer_Menu_Credits'), href: getLinkHref(pageContext, '/credits') }
    ];
    return (
        <div className={clsx(styles.footerWrapper, pageContext.config.flatFooter && styles.flatFooter)}>
            <Flex justify="space-between" align="center" className={styles.footer}>
                <img src={LOGO_URL} alt="logo" className={styles.logo} />
                <Flex align="center" gap={64}>
                    {items.map(item => (
                        <a key={item.label} href={item.href} target={item.target}>{item.label}</a>
                    ))}
                </Flex>
                <a href={DISCORD_LINK} target="_blank" rel="noreferrer noopener">
                    <Icon.Discord size={32} center />
                </a>
            </Flex>
        </div>
    );
};
